module.exports = __webpack_public_path__ + "static/media/table2-flower.8ae5662a.png";